import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export const reconnectingSocket = (url, saveSocketData, topic, location) => {
  const socket = new SockJS(url, undefined, { timeout: 25000, transports: 'websocket' })
  const stompClient = Stomp.over(socket)
  let subscription = null
  let recInterval = null
  let allowReconnect = true

  const stopReconnect = () => {
    allowReconnect = false
    if (recInterval) {
      clearInterval(recInterval)
      recInterval = null
    }
  }

  stompClient.debug = null // Disable verbose STOMP logging

  stompClient.connect({}, function () {
    subscription = stompClient.subscribe(topic, function (d) {
      saveSocketData(d)
    })
  })

  socket.onclose = () => {
    if (!allowReconnect) return
    if (window.location.href === location) {
      recInterval = setInterval(() => {
        reconnectingSocket(url, saveSocketData, topic, location)
      }, 5000)
    }
  }

  const disconnect = () => {
    stopReconnect()
    try {
      if (subscription?.unsubscribe) subscription.unsubscribe()
      if (stompClient?.disconnect) stompClient.disconnect(() => {})
      if (socket?.close) socket.close()
    } catch (error) {
      // Ignore errors during cleanup - connection may not be fully established
      console.warn('Error during WebSocket cleanup:', error)
    }
  }

  return { stompClient, subscription, socket, disconnect }
}
